export default __webpack_public_path__ + "static/media/1123.d12d9ca6.png";